import { ResponseType } from 'axios';
import apiInstance from './instances/apiInstances';

export const toDataURL = (url: string, callback: any) => {
  apiInstance.get(url, {
    responseType: 'blob',
    baseURL: '',
  }).then((response) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(response.data);
  }).catch((err) => {
    if (err.status === 500 || err.status === 403) {
      callback('');
    }
  });
};

export const callGetEndpoint = <T>(
  url: string,
  responseType: ResponseType = 'json',
): Promise<T> => {
  return new Promise((resolve, reject) => {
    apiInstance
      .get(url, { baseURL: '', responseType })
      .then((response) => resolve(response.data))
      .catch((err) => reject(err));
  });
};

export const callPostEndpoint = <T>(
  url: string,
  data: FormData,
  responseType: ResponseType = 'json',
): Promise<T> => {
  return new Promise((resolve, reject) => {
    apiInstance
      .post(url, data, { baseURL: '', responseType })
      .then((response) => resolve(response.data))
      .catch((err) => reject(err));
  });
};

export const callPutEndpoint = <T>(
  url: string,
  data: FormData,
  responseType: ResponseType = 'json',
): Promise<T> => {
  return new Promise((resolve, reject) => {
    apiInstance
      .put(url, data, { baseURL: '', responseType })
      .then((response) => resolve(response.data))
      .catch((err) => reject(err));
  });
};
